module.exports = __webpack_public_path__ + "img/plus-box.d8049f3c.svg";